var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.762,
    height: 33.25,
    viewBox: "0 0 30.762 33.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-2187.297 1050.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M2385.683-815.857a1.945,1.945,0,0,0-.731-.184,7.065,7.065,0,0,1-5.43-7.141,7.054,7.054,0,0,1,5.868-6.646,7.041,7.041,0,0,1,8.138,5.958,7.034,7.034,0,0,1-6.126,7.949c-.045.005-.084.011-.095.063Zm3.527-10.265c-.08.093-.146.178-.221.256-1.066,1.106-2.14,2.205-3.2,3.322-.2.211-.284.181-.454-.022-.451-.539-.933-1.052-1.39-1.587-.124-.144-.193-.139-.325-.015q-.546.509-1.118.989c-.141.118-.142.19-.019.328q1.439,1.609,2.859,3.234c.126.144.192.141.32,0,.526-.56,1.065-1.108,1.6-1.66q1.59-1.646,3.179-3.293c.088-.091.24-.158.055-.326C2390.066-825.282,2389.654-825.7,2389.21-826.122Z",
    transform: "translate(-175.539 -201.878)",
    fill: "#1e434d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M2204.363-963.595c1.471-.005,2.942-.007,4.413-.019.236,0,.186.156.194.285q.093,1.539.181,3.077c.117,2.03.228,4.061.353,6.091.016.258-.054.335-.315.386a9,9,0,0,0-7.042,7.38,8.939,8.939,0,0,0,.763,5.272c.031.066.057.134.1.238h-.183q-5.226,0-10.451,0a4.874,4.874,0,0,1-4.419-2.468,4.486,4.486,0,0,1-.654-2.6c.119-2.3.263-4.6.4-6.9q.181-3.094.365-6.187.129-2.187.255-4.374c.007-.125.021-.2.176-.195,1.482.011,2.963.014,4.445.019l-.01-.008c0,1.374.009,2.749,0,4.123,0,.2.047.259.25.253.476-.015.953-.019,1.428,0,.233.01.282-.063.281-.286-.01-1.364,0-2.727,0-4.091l-.01.01c.118-.006.236-.017.354-.017q3.012,0,6.025,0c.388,0,.777.011,1.165.017l-.01-.01c-.005,1.4-.008,2.79-.02,4.185,0,.171.071.191.212.189.5-.006,1-.012,1.493,0,.2.006.256-.06.252-.257-.011-.638-.007-1.277,0-1.915,0-.734.015-1.469.023-2.2Z",
    transform: "translate(0 -79.79)",
    fill: "#1e434d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M2252.23-1043.384a18.044,18.044,0,0,1,.116-3.042,5.719,5.719,0,0,1,5.389-4.559,5.715,5.715,0,0,1,5.723,4.308,6.723,6.723,0,0,1,.176,1.542q.007.875.017,1.75l.007-.006H2261.7l.01.01c-.009-.129-.022-.257-.025-.386-.018-.67.034-1.341-.043-2.01a3.76,3.76,0,0,0-3.664-3.258,3.756,3.756,0,0,0-3.748,3.16c-.118.829-.019,1.664-.064,2.495l.01-.01h-1.957Z",
    transform: "translate(-59.288 0)",
    fill: "#1e434d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcd);
export default __webpack_public_path__ + "static/media/ecd.373cd4cd0f64bb24c7cbc0be94c400b4.svg";
export { ForwardRef as ReactComponent };